// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-page .logo-container{margin-top:6rem}.home-page .logo{max-height:150px}", "",{"version":3,"sources":["webpack://./src/components/home-page/HomePage.scss"],"names":[],"mappings":"AACE,2BACE,eAAA,CAGF,iBACE,gBAAA","sourcesContent":[".home-page {\n  .logo-container {\n    margin-top: 6rem;\n  }\n\n  .logo {\n    max-height: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
